import { FC } from 'react';
import { MultiSelectField } from 'components/Forms/MultiSelectField';
import { MISSING_RECIPIENT_NOTE } from 'constants/recipients';
import { CRITERIA_NOTE } from '../constants';
import { RecipientOption } from './types';
import { SelectedRecipients } from './SelectedRecipients';
import { UnavailableRecipientsNote } from './UnavailableRecipientsNote';
import { requireRecipients } from './utils';

type Props = {
  options: RecipientOption[];
  showsCriteriaNote: boolean;
};

export const FilterRecipientsSection: FC<Props> = ({ options, showsCriteriaNote }) => (
  <>
    <div className="row">
      <div className="col-md-6 padding-left0">
        <MultiSelectField
          name="recipients"
          label="Recipients *"
          options={options}
          validate={requireRecipients}
        />
      </div>
      <div className="col-md-6 padding0">
        <div className="recipient-label oath-utility">{MISSING_RECIPIENT_NOTE}</div>
      </div>
    </div>
    <SelectedRecipients />
    {showsCriteriaNote && <p className="oath-utility gray">{CRITERIA_NOTE}</p>}
    <UnavailableRecipientsNote />
  </>
);
